export const color = {
  themeBackgroundMain: "#c4c4c4",
  themeMain: "#428bca",
  textWhite: "white",
};
